import { request } from '@/plugins/plugin-request';
import axios from '@didi/dajax';
import { getAuthParams } from '@/plugins/plugin-sso-login';
import { prefixUrl } from '@/utils';
export function getUserAuthCountry(params = {}) {
  return request
    .get({
      url: 'common.getUserAuthCountry',
      params,
    })
    .then((res) => res.data)
    .catch((e) => console.error(e));
}

export function getMyBusiness(params = {}) {
  return request
    .get({
      url: 'common.getMyBusiness',
      params,
    })
    .then((res) => res.data)
    .catch((e) => console.error(e));
}

export function updateUserConfig(params) {
  return request
    .post({
      url: 'common.updateUserConfig',
      params: params,
    })
    .then((res) => res.data);
}

export function getFeatureAuth(params) {
  if (!params.nodeKey) return;
  return request
    .get({
      url: 'common.getFeatureAuth',
      params: params,
    })
    .then((res) => res.data);
}

export function checkFeatureAuth(params) {
  if (!params.nodeKey) return;
  return request
    .get({
      url: 'common.checkFeatureAuth',
      params: params,
    })
    .then((res) => res.data);
}

export function getUserInfoV1() {
  return request.get({
    url: 'common.getUserInfoV1',
  });
}

export function getUserInfo() {
  const targetUrl = prefixUrl('/common');
  return axios.get(targetUrl, {
    params: {
      ...getAuthParams(),
      api: 'common.getUserInfo',
    },
    timeout: 300000,
    needEncrypt: true,
  });
}
